import { useEffect, useState } from 'react';
import useResetFiltersOnReload from './hooks/useResetFiltersOnReload';
import CommonRoutes from './Routes/CommonRoutes';
import { authChannel, showToastNotification } from './utility/helper';
import { messaging } from './firebase-messaging';
import NoInternet from './pages/CommonPages/NoInternet';
import { useDispatch } from 'react-redux';
import { setNotificationCount } from './redux/features/UserSlice';
import { INotificationCountRes } from './interfaces/common.model';
import { callApi, IApiErrorResponse } from './api/callApi';
import { API_ENDPOINT, API_URL } from './api/constant';
import { onMessage } from 'firebase/messaging';

const App: React.FC = () => {
  const [isOnline, setIsOnline] = useState(navigator.onLine);
  const dispatch = useDispatch();
  useEffect(() => {
    authChannel.onmessage = (event) => {
      if (event.data === 'logout' || event.data === 'login') {
        window.location.reload();
      }
    };

    onMessage(messaging, (payload) => {
      getNotificationCount();
      showToastNotification('info', payload?.notification?.title ?? "");
    });

    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);
  const getNotificationCount = async () => {
    try {
      const response: INotificationCountRes = await callApi(
        API_URL + API_ENDPOINT.getNotificationCount,
        {
          method: 'GET',
        },
      );
      if (response?.status) {
        dispatch(setNotificationCount(response?.data));

      }
    } catch (error) {
      if (error && typeof error === 'object' && 'message' in error) {
        showToastNotification('danger', (error as IApiErrorResponse).message);
      } else {
        showToastNotification('danger', 'Something went wrong');
      }
    }
  };
  useResetFiltersOnReload();

  if (!isOnline) {
    return <NoInternet />;
  }

  return (
    <>
      <CommonRoutes />
    </>
  );
};

export default App;
